import type { PagesConfig } from '#types/config/pages'

export default {
  brandClasses: {
    formContainer: 'max-w-130 w-full pb-16 pt-14 container',
    requiredField: 'mb-2 text-xs c-grey-20'
  }
} satisfies PagesConfig['resetPassword']
